import script from "./estimate.vue?vue&type=script&setup=true&lang=js"
export * from "./estimate.vue?vue&type=script&setup=true&lang=js"

import "./estimate.vue?vue&type=style&index=0&id=3622e477&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3622e477"]])

export default __exports__